<div class="title" #title>
  <div class="container container-max-width">
    <h4>Third Party Customer Management</h4>
    <p style="line-height: 20px">
      Use this management page to manage third-party customer subscription's access
      <br />
    </p>
  </div>
</div>

<div class="container container-content container-max-width" (window:resize)="onResize()" [style.height]="containerHeight">
  <div class="landing-main">
    <br />
    <!-- Backfill Customer Subscription Access Section -->
    <div>
      <h5>Backfill Customer Subscription Access:</h5>
      <form #backfillForm="ngForm" autocomplete="off" novalidate>

        <!--Backfill By -->
        <div class="form-group">
          <h6>Backfill By:</h6>
          <label style="width: 100%">
            <ng-select
              name="backfillBy"
              labelForId="backfillBy"
              [items]="backfillByNames"
              [(ngModel)]="backfillBy"
              (ngModelChange)="onBackfillByChanged()"
              bindLabel="backfillBy"
              bindValue="backfillBy"
              required
            >
            </ng-select>
          </label>
        </div>

        <!--Backfill Input-->
        <div class="form-group"
             [ngClass]="{
                error: backfillForm.controls.backfillInput?.invalid && backfillForm.controls.backfillInput?.touched
             }">
          <h6>{{ backfillBy }}:</h6>
          <input
            class="form-control"
            [(ngModel)]="backfillInput"
            name="backfillInput"
            title="backfillInput"
            id="backfillInput"
            type="text"
            placeholder="Enter {{ backfillByConfig.name }}"
            required
            [pattern]="backfillByConfig.regexPattern"
            (ngModelChange)="onBackfillInputChanged()"
          />
          <em *ngIf="backfillForm.controls.backfillInput?.invalid && backfillForm.controls.backfillInput?.touched">
            {{ backfillByConfig.regexErrorMessage }}
          </em>
        </div>

        <!--Region-->
        <div class="form-group"
          [ngClass]="{
            error: backfillForm.controls.regions?.invalid && backfillForm.controls.regions?.touched
          }">
          <h6>Region(s):</h6>
          <label style="width: 100%">
            <ng-select
              name="regions"
              labelForId="regions"
              [items]="regionsList"
              bindLabel="region"
              bindValue="region"
              groupBy="cloud"
              required
              [multiple]="true"
              [(ngModel)]="selectedRegions"
              placeholder="Enter region name"
            >
            </ng-select>
          </label>
          <em *ngIf="backfillForm.controls.regions?.invalid && backfillForm.controls.regions?.touched">Required</em>
        </div>

        <!--Calculate Button-->
        <div class="form-group nofloat">
          <button
            type="button"
            class="btn btn-primary me-1"
            [disabled]="backfillForm.controls.backfillInput?.invalid"
            (click)="calculateSubscriptionCount()"
          >
            Calculate Number of Subscriptions
          </button>
        </div>

        <!--Subscription Count Message-->
        <div *ngIf="subscriptionCountMessage" class="form-group">
          <p><strong>{{ subscriptionCountMessage }}</strong></p>
        </div>

        <!--Proceed to Backfill Button-->
        <div *ngIf="showProceedButton" class="form-group nofloat">
          <button
            type="button"
            class="btn btn-success me-1"
            [disabled]="backfillForm.invalid"
            (click)="proceedToBackfill()"
          >
            Proceed to backfill
          </button>
        </div>
      </form>
    </div>

    <hr />

    <!-- Monitor Customer Access Section -->
    <div>
      <h5>Monitor Customer Access:</h5>
      <form #monitorForm="ngForm" autocomplete="off" novalidate>
        <!--Tables Dropdown-->
        <div class="form-group">
          <h6>Tables:</h6>
          <label style="width: 100%">
            <ng-select
              name="tables"
              labelForId="tables"
              [items]="tableOptions"
              [(ngModel)]="selectedTable"
              (change)="onTableChanged()"
            >
            </ng-select>
          </label>
        </div>

        <!--Grid Actions-->
        <div class="hint leftalign">
          {{ selectedRowCount }} row(s) selected &nbsp;&nbsp;|&nbsp;&nbsp;
          <a href="javascript:void(0)" class="topbar-item" (click)="refreshGrid()" container="body"> Refresh </a>
          <ng-container *ngIf="selectedTable === 'CustomerRegion'">
            &nbsp;&nbsp;
            <a href="javascript:void(0)" class="topbar-item" (click)="insertRow()" container="body"> Insert Row </a>
            &nbsp;&nbsp;
            <a href="javascript:void(0)" class="topbar-item" (click)="deleteAllowlist()" container="body"> Delete </a>
          </ng-container>
        </div>

        <!--Grid-->
        <div class="nofloat">
          <grid-filter-pills [gridApi]="gridApi" *ngIf="gridApi"></grid-filter-pills>
          <ag-grid-angular
            style="height: 540px"
            class="ag-theme-balham"
            [gridOptions]="gridOptions"
            [rowData]="rowData"
            [masterDetail]="true"
            (gridReady)="onGridReady($event)"
            (selectionChanged)="onSelectionChanged($event)"
            [pagination]="true"
            rowSelection="multiple"
          >
          </ag-grid-angular>
        </div>
        <br />
      </form>
    </div>
  </div>
</div>
